
function getPrimaryAddress(contact) {
  if (Array.isArray(contact.addresses)) {
    return contact.addresses.find(a => a.primary) || null;
  }
  return null;
}

import { get, post } from 'helpers/api';

const rootPath = '/integrations/quickbooks/account';

export async function search({ type, ...fields }, callback) {
  const results = await get(`${rootPath}/search`, { params: { type, ...fields } });
  callback(results);
}

export async function loadObject({ type, id }, callback, onError) {
  try {
    const result = await get(`${rootPath}/object/${type}/${id}`);
    callback(result);
  } catch (error) {
    onError?.(error);
  }
}

export async function createObject({ type, ...fields }, onSuccess, onError) {
  try {
    const result = await post(`${rootPath}/object/${type}`, fields);
    onSuccess(result);
  } catch (error) {
    onError?.(fields, error);
  }
}

export function buildCustomerBody(contact) {
  const mobilePhone = contact.phoneNumbers?.find(p => p.label === 'Mobile')?.number;
  const fax = contact.phoneNumbers?.find(p => p.label === 'Fax')?.number;
  const otherEmail = contact.additionalEmails?.[0]?.email;

  const primaryAddress = getPrimaryAddress(contact);
  const billingAddress = primaryAddress && {
    line_one: primaryAddress.addressOne,
    line_two: primaryAddress.addressTwo,
    city: primaryAddress.city,
    state: primaryAddress.state,
    zip: primaryAddress.zip,
  };

  return {
    contactType: contact.contactType,
    ...(contact.contactType === 'business'
      ? { name: contact.name }
      : { givenName: contact.firstName, familyName: contact.lastName }),
    ...(contact.email && { email: contact.email }),
    ...(contact.phoneNumber && { phone: contact.phoneNumber }),
    ...(mobilePhone && { mobilePhone }),
    ...(fax && { fax }),
    ...(otherEmail && { otherEmail }),
    ...(billingAddress && { billingAddress }),
  };
}

export function buildVendorBody(buildoutObject) {
  if (buildoutObject.contactType) {
    return buildVendorBodyFromContact(buildoutObject);
  } else {
    return buildVendorBodyFromBroker(buildoutObject);
  }
}


function buildVendorBodyFromContact(contact) {
  const mobilePhone = contact.phoneNumbers?.find(p => p.label === 'Mobile')?.number;
  const fax = contact.phoneNumbers?.find(p => p.label === 'Fax')?.number;
  const otherEmail = contact.additionalEmails?.[0]?.email;
  const primaryAddress = getPrimaryAddress(contact);
  const billingAddress = primaryAddress && {
    line_one: primaryAddress.addressOne,
    line_two: primaryAddress.addressTwo,
    city: primaryAddress.city,
    state: primaryAddress.state,
    zip: primaryAddress.zip,
  };

  return {
    contactType: contact.contactType,
    ...(contact.contactType === 'business'
      ? { name: contact.name }
      : { givenName: contact.firstName, familyName: contact.lastName }),
    ...(contact.email && { email: contact.email }),
    ...(contact.phoneNumber && { phone: contact.phoneNumber }),
    ...(mobilePhone && { mobilePhone }),
    ...(fax && { fax }),
    ...(otherEmail && { otherEmail }),
    ...(billingAddress && { billingAddress }),
  };
}

function buildVendorBodyFromBroker(broker) {
  return {
    displayName: broker.name,
    ...(broker.email && { email: broker.email }),
    ...(broker.phoneFormatted && { phone: broker.phoneFormatted }),
    ...(broker.addressFormatted && { address: broker.addressFormatted }),
  };
}

const BODY_BUILDERS = { customer: buildCustomerBody, vendor: buildVendorBody };

export function buildCreateBody(type, data) {
  return BODY_BUILDERS[type](data);
}
